import React from 'react'
import { Outlet, useLocation } from 'react-router'
// TODO: validar porque tem em vários componentes o comentário // Componentes
// Componentes
import { HotsiteFooter } from '../../../../../../shared/src/domain/feature/hotsite/Footer'
import { HotsiteHeader, HotsiteHeaderProps } from '../../../../../../shared/src/domain/feature/hotsite/Header'

import { ROUTES } from '../../../../../../shared/src/constants'
import { HotsiteContentWrapper, HotsitePageWrapper } from './styles'
import { MARKETING_LP_URL } from '../../../constants/links'

const hotsiteHeaderConfig: HotsiteHeaderProps = {
  showDemoButton: false,
  showNavLinks: false,
  logoHref: MARKETING_LP_URL,
}

export const HotsiteInnerPage = (): React.ReactElement => {
  const location = useLocation()
  return (
    <HotsitePageWrapper>
      {location.pathname !== ROUTES.HOTSITE.INNOVATION_MAP ? <HotsiteHeader {...hotsiteHeaderConfig} /> : <></>}
      <HotsiteContentWrapper>
        <Outlet />
      </HotsiteContentWrapper>
      <HotsiteFooter />
    </HotsitePageWrapper>
  )
}
